import { twMerge } from 'tailwind-merge';

// eslint-disable-next-line import/prefer-default-export
export function HrWithText({ text, textClassName }: { text: string; textClassName?: string }) {
  return (
    <div className="inline-flex items-center justify-center w-full">
      <hr className="w-full h-px my-8 bg-gray-200 border-0" />
      <span
        className={twMerge('absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2', textClassName)}
      >
        {text}
      </span>
    </div>
  );
}
